import { render, staticRenderFns } from "./GiftCardConfirmPayment.vue?vue&type=template&id=32c95c82&scoped=true"
import script from "./GiftCardConfirmPayment.vue?vue&type=script&lang=js"
export * from "./GiftCardConfirmPayment.vue?vue&type=script&lang=js"
import style0 from "./GiftCardConfirmPayment.vue?vue&type=style&index=0&id=32c95c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c95c82",
  null
  
)

export default component.exports